<template>
  <div class="h-100">
    <div class="row h-100">
      <div class="col-md-12">
        <div v-if="isLoaded">
          <div class="text-center">
            <div
              class="box-block_short box-block text-center"
              v-cloak
              v-if="!resultsList.length"
            >
              <div class="alert alert-primary">
                {{ $t('team.emptyResultList') }}
              </div>
            </div>
            <div v-else v-cloak class="dates dates_users">
              <div class="legend">
                <div class="legend__header">
                  {{ $t('legend') }}
                </div>

                <div class="legend__item">
                  <div class="icon icon-success-badge"></div>
                  <div>{{ $t('SucceededStatus') }}</div>
                </div>

                <div class="legend__item">
                  <div class="icon icon-fail-badge"></div>
                  <div>{{ $t('FailedStatus') }}</div>
                </div>
              </div>
              <table
                class="table profile-table table-responsive-lg overflow-y-xs text-left"
              >
                <th></th>
                <th>{{ $t('id') }}</th>
                <th>{{ $t('form.name') }}</th>
                <th>{{ $t('courseLanguage') }}</th>
                <th>{{ $t('training') }}</th>
                <th>{{ $t('RegistrationDate') }}</th>
                <!--<th>{{ $t('sessionDate') }}</th>-->
                <th>{{ $t('form.status') }}</th>
                <tbody class="box-block">
                  <result-row
                    v-for="(result, index) in resultsList"
                    :key="result.resultID"
                    :index="index"
                    :result="result"
                    :user="user"
                  ></result-row>
                </tbody>
              </table>
              <div class="row mt-3 mb-3">
                <div class="col-sm-12 d-flex justify-content-between">
                  <div class="">
                    <button
                      class="btn btn-filter btn-icon"
                      @click="previousPage()"
                    >
                      <span class="icon icon-arrow-left" /> {{ $t('previous') }}
                    </button>
                  </div>
                  <div>{{ $t('pagination', [page, totalPages]) }}</div>
                  <div class="">
                    <button class="btn btn-filter btn-icon" @click="nextPage()">
                      {{ $t('next') }} <span class="icon icon-arrow-right" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="h-100">
          <div
            class="h-100 row d-flex justify-content-center align-items-center"
          >
            <div class="col-12">
              <div class="d-flex justify-content-center align-items-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmationModal from '@/js/components/modals/ConfirmationModal.vue'
import ResultRow from './ResultRow.vue'
import FilterModal from './FilterModal.vue'
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'TraineeResults',
  components: {
    ConfirmationModal,
    ResultRow,
    FilterModal,
  },
  data() {
    return {
      page: 1,
      q: '',
      resultsList: [],
      isFiltred: false,
      form: {
        firstname: null,
        lastname: null,
        birthday: null,
        email: null,
        gender: 0,
      },
      isLoaded: false,
      locale: '',
      filterData: {},
      monitor: {
        visible: false,
        message: '',
        type: 'text-warning',
      },
    }
  },
  computed: {
    ...mapFields(['user', 'establishment', 'company']),
    ...mapFields([
      'traineeResults.results',
      'traineeResults.pagination',
      'traineeResults.isFiltrSelected',
      'traineeResults.selectedResults',
      'traineeResults.filtredResults',
      'traineeResults.isAllResultsSelected',
    ]),
    totalPages() {
      return this.$lodash.get(this.pagination, 'total_pages', 1)
    },
    isSelected() {
      if (this.isAllResultsSelected) {
        return this.pagination.total
      } else return this.selectedResults.length
    },
  },
  watch: {
    page: (val) => {
      if (val < 1) this.page = 1
    },
    $route: {
      handler(to, from) {
        if (this.$lodash.get(this.$route, 'query', false)) {
          let a = { ...{ page: 1, limit: this.limit }, ...this.$route.query }
          console.log('a watch', a)
          this.getResults(a)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.filtredResults = []
    this.isFiltrSelected = false
    this.isFiltred = false

    this.locale = this.user.local
    this.$bus.$on('registration-filter', (data) => {
      console.log('registration-filter = ', data)
      this.filter(data).then(() => {
        this.filterData.startDate = data.startDate
        this.filterData.endDate = data.endDate
        this.filterData.languge = data.languge
        this.filterData.training = data.training
        this.filterData.status = data.status
        this.$bus.$emit('hide-filter-registration-modal')
      })
    })
  },
  beforeMount() {
    this.$bus.$off('registration-filter')
  },
  methods: {
    showFilterModal() {
      this.$bus.$emit('filter-registration-modal.show')
    },
    nextPage() {
      if (
        this.pagination.total_pages > 1 &&
        this.page < this.pagination.total_pages
      ) {
        this.page++
        let a = {
          ...this.$route.query,
          ...{ page: this.page, limit: this.limit },
          ...{
            startDate: this.filterData?.startDate ?? null,
            endDate: this.filterData?.endDate ?? null,
            languge: this.filterData?.languge ?? null,
            training: this.filterData?.training ?? null,
            status: this.filterData?.status ?? null,
          },
        }
        console.log('a  = ', a)
        this.$router.push({ name: 'Results', query: a }).catch((error) => {})
      }
    },
    previousPage() {
      if (this.pagination.total_pages > 1 && this.page > 1) {
        this.page--
        let a = {
          ...this.$route.query,
          ...{ page: this.page, limit: this.limit },
          ...{
            startDate: this.filterData?.startDate ?? null,
            endDate: this.filterData?.endDate ?? null,
            languge: this.filterData?.languge ?? null,
            training: this.filterData?.training ?? null,
            status: this.filterData?.status ?? null,
          },
        }
        console.log('a  = ', a)
        this.$router.push({ name: 'Results', query: a }).catch((error) => {})
      }
    },
    search() {
      if (this.q != '') {
        this.isLoaded = false
        this.selectedResults = []
        let payload = {
          params: {
            action: 'search',
            q: this.q,
          },
          id: this.user.id,
        }
        this.$store
          .dispatch('traineeResults/searchResults', payload)
          .then((response) => {
            console.log('responseSearchResults ', response)
            this.resultsList = this.filtredResults
          })
          .finally(() => {
            this.isLoaded = true
          })
      } else {
        let a = { ...this.$route.query, ...{ page: 1, limit: this.limit } }
        this.filtredResults = []
        this.getResults(a)
      }
    },

    getResults(params) {
      console.log('getResults params ', params)
      this.isLoaded = false
      this.$store
        .dispatch('traineeResults/getResultsByClientId', params)
        .then(() => {
          console.log(this.results)
          this.resultsList = this.results
          console.log('this.resultsList ', this.resultsList)
          if (this.isAllResultsSelected) {
            this.selectedResults = []
            this.$lodash.forEach(this.resultsList, (result) => {
              this.selectedResults.push(result.registrationId)
            })
          }
        })
        .finally(() => {
          this.isLoaded = true
        })
    },
    toggleSelectedFiltered() {
      this.isFiltrSelected = !this.isFiltrSelected
      this.isAllResultsSelected = false
      this.selectedResults = []
      if (this.selectedResults) {
        this.$lodash.forEach(this.filtredResults, (result) => {
          this.selectedResults.push(result.registrationId)
        })
      }
    },
    toggleSelectAllResults() {
      this.isAllResultsSelected = !this.isAllResultsSelected
      this.isFiltrSelected = false
      this.selectedResults = []

      if (this.isAllResultsSelected) {
        this.$lodash.forEach(this.results, (result) => {
          this.selectedResults.push(result.resultID)
        })
      }
    },
    unsubscribe() {
      this.isLoaded = false
      const data = {
        companyId: this.company.id,
        resultIds: this.selectedResults,
      }
      this.$store
        .dispatch('traineeResults/deleteRegistration', data)
        .then((response) => {
          let a = { ...this.$route.query, ...{ page: 1, limit: this.limit } }
          this.getResults(a)
        })
        .finally(() => {
          this.isLoaded = true
        })
    },
    deletedResults() {
      this.isLoaded = false
      const data = {
        resultIds: this.selectedResults,
      }
      this.$store
        .dispatch('traineeResults/deleteResults', data)
        .then((response) => {
          let a = { ...this.$route.query, ...{ page: 1, limit: this.limit } }
          this.getResults(a)
        })
        .finally(() => {
          this.isLoaded = true
        })
    },
    monitorHide() {
      this.monitor.type = ''
      this.monitor.message = ''
      this.monitor.visible = false
    },
  },
}
</script>

<style></style>
